import { onBeforeUnmount, ref } from 'vue'

import { notifyError, notifySuccess } from '@/utils/ui/handleNotification'

import * as aggr from '@/api-generator/aggr'
import { feUserProfileAPI } from '@/APIs'

export const useSSOAccounts = () => {
  const isSSOAccountLoading = ref(true)
  const isSSOAccountBinding = ref(false)
  const ssoAccounts = ref<aggr.UserProfileGetCurrentUserBindSsoAccountsRs[]>([])

  /** 取得綁定第三方帳號清單 */
  const handleGetSSOAccounts = async () => {
    isSSOAccountLoading.value = true
    try {
      const { data } = await feUserProfileAPI.getUserSSOAccounts()
      ssoAccounts.value = data
    } catch (error) {
      console.error(error)
    } finally {
      isSSOAccountLoading.value = false
    }
  }

  /** 綁定第三方帳號 */
  const handleBindSSOAccount = async (bindAccessToken: string) => {
    isSSOAccountBinding.value = true
    const reqBody: aggr.UserProfileBindSsoTokenRq = {
      bindAccessToken
    }
    try {
      await feUserProfileAPI.bindUserSSOToken(reqBody)
      notifySuccess('綁定帳號成功')
      handleGetSSOAccounts()
    } catch (error: any) {
      console.error(error)
      const errorMsg = error.response && error.response.data.message
      notifyError(errorMsg || '綁定失敗')
    } finally {
      isSSOAccountBinding.value = false
    }
  }

  onBeforeUnmount(() => {
    isSSOAccountLoading.value = true
    isSSOAccountBinding.value = false
  })

  return { handleBindSSOAccount, handleGetSSOAccounts, isSSOAccountLoading, isSSOAccountBinding, ssoAccounts }
}
